import moment from "moment";

export default {
    filters: {
        receiptDate(value) {
            return moment(value).format('DD-MM-YYYY');
        }
    }
}